/**
 * The Stock column's flag, the way buyers say it: Y for a stocked item, N for
 * a non-stock one. A line without an inventory policy has no flag, and an
 * unexpected status shows as it came rather than being hidden.
 */
export function stockFlag(status: string | null | undefined): string | null {
  if (!status) return null;
  if (status === 'stocked') return 'Y';
  if (status === 'non_stock') return 'N';
  return status;
}
